import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyTeam = {
  // 编辑/新增员工
  userAddOrEdit(params) {
    return http.post(`${baseUrl}User/addOrEdit`, params)
  },
  // 删除组织成员
  delUser(params) {
    return http.post(`${baseUrl}User/del`, params)
  },
  // 修改成员密码
  changeUserPassword(params) {
    return http.post(`${baseUrl}User/changePassword`, params)
  },
  // 编辑成员角色
  changeUserRole(params) {
    return http.post(`${baseUrl}User/setRole`, params)
  },
  // 修改登录状态
  changeUserLogin(params) {
    return http.post(`${baseUrl}User/allowLogin`, params)
  },
  // 获取航阳快速预定路径code免登录
  getHangYangUrl(params) {
    return http.post(`${baseUrl}HelpCustomer/getUrl`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyTeam.js